export function EmptySystemThinkingPlaceholder() {
  return (
    <div className="flex h-full flex-col items-center justify-center text-brand-muted gap-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="24"
        viewBox="0 0 23 24"
        fill="none"
        className="text-brand-primary"
      >
        <path
          d="M1.61619 3.19881H0V0H1.61619C4.25458 0 6.608 1.26576 8.08649 3.21306C9.56579 1.26576 11.9184 0 14.5568 0C19.0042 0 22.6433 3.59935 22.6449 7.99662V16.0077C22.6456 16.888 21.918 17.6076 21.0278 17.6076C20.1378 17.6076 19.4102 16.888 19.4102 16.0077V7.99741C19.4102 5.35826 17.228 3.19881 14.5584 3.19881C11.8888 3.19881 9.70506 5.35826 9.70506 7.99741V16.0077C9.70425 16.888 8.97743 17.6076 8.08729 17.6076C7.19716 17.6076 6.46952 16.888 6.46952 16.0077V7.99741C6.46952 5.35826 4.28501 3.19881 1.61619 3.19881Z"
          fill="currentColor"
        />
        <path
          d="M21.0287 20.8011H22.6449V24H21.0287C18.3903 24 16.0368 22.7343 14.5584 20.7869C13.0791 22.7343 10.7265 24 8.08808 24C3.6406 24 0.00160509 20.4006 3.0323e-06 16.0033L6.5878e-07 7.99219C-0.00079918 7.11195 0.726831 6.3924 1.61696 6.3924C2.5071 6.3924 3.23474 7.11195 3.23474 7.99219V16.0026C3.23474 18.6417 5.41688 20.8011 8.08648 20.8011C10.7561 20.8011 12.9398 18.6417 12.9398 16.0026V7.99219C12.9406 7.11195 13.6674 6.3924 14.5576 6.3924C15.4477 6.3924 16.1753 7.11195 16.1753 7.99219V16.0026C16.1753 18.6417 18.3598 20.8011 21.0287 20.8011Z"
          fill="currentColor"
        />
      </svg>
      <p className="text-sm">The system reasoning will appear here.</p>
    </div>
  );
}
